// @flow
import * as Immutable from "immutable";
import React from "react";
import $ from "jquery";
import {
  ContentState,
  EditorState,
  Modifier,
  BlockMapBuilder,
  ContentBlock,
  genKey
} from "draft-js";
import { convertFromHTML, convertToHTML } from "draft-convert";

export function replaceCurrentBlockWithAtomicBlock(
  editorState: EditorState,
  atomicBlockData: Object
): EditorState {
  const contentState = editorState.getCurrentContent();
  const currentContentBlock = getCurrentContentBlock(editorState);
  const currentBlockKey = currentContentBlock.get("key");

  const newAtomicBlock = new ContentBlock({
    key: currentBlockKey,
    type: "atomic",
    text: "",
    characterList: Immutable.List(),
    data: Immutable.Map(atomicBlockData)
  });

  const contentStateWithNewBlock = contentState.setIn(
    ["blockMap", currentBlockKey],
    newAtomicBlock
  );

  return EditorState.push(
    editorState,
    contentStateWithNewBlock,
    "insert-fragment"
  );
}

export function getCurrentContentBlock(editorState: EditorState): ContentBlock {
  const selectionState = editorState.getSelection();
  const anchorKey = selectionState.getAnchorKey();
  return editorState.getCurrentContent().getBlockForKey(anchorKey);
}

export function isCurrentContentBlockBlank(editorState: EditorState): boolean {
  const currentContentBlock = getCurrentContentBlock(editorState);
  return Boolean(
    currentContentBlock.text === "" && currentContentBlock.type === "unstyled"
  );
}

export function extendedConvertFromHTML(html: string): ContentState {
  return convertFromHTML({
    htmlToStyle: (nodeName: string, node: HTMLElement, currentStyle) => {
      if (nodeName == "sup") {
        return currentStyle.add("SUPERSCRIPT");
      }
      if (nodeName == "sub") {
        return currentStyle.add("SUBSCRIPT");
      }
      return currentStyle;
    },
    htmlToBlock: (nodeName: string, node: HTMLElement) => {
      if (nodeName == "div") {
        const assetId = Number($(node).attr("data-asset_id"));
        if (assetId > 0) {
          const type = "ap-asset";
          return {
            type: "atomic",
            data: { type, assetId }
          };
        }
      }
    }
  })(html);
}

export function extendedConvertToHTML(contentState: ContentState): string {
  const result = convertToHTML({
    styleToHTML: style => {
      if (style == "SUPERSCRIPT") {
        return <sup />;
      }
      if (style == "SUBSCRIPT") {
        return <sub />;
      }
    },
    blockToHTML: block => {
      if (block.type == "atomic") {
        if (block.data.type == "ap-asset") {
          return <div data-asset_id={block.data.assetId} />;
        }
      }
    }
  })(contentState);
  if (result == null) {
    return "";
  }
  return result;
}

function cleanContentState(contentState: ContentState): ContentState {
  const { blockMap } = contentState;
  const updatedBlockMap = blockMap
    // trim leading and trailing whitespace from text
    .map(block => block.set("text", block.text.trim()))
    // delete empty unstyled blocks
    .filterNot(block => block.text.trim() === "" && block.type === "unstyled");
  // if we've ended up with an empty blockmap, return a new contentstate
  // with a single empty unstyled block
  if (updatedBlockMap.size == 0) {
    return ContentState.createFromText("");
  } else {
    return contentState.set("blockMap", updatedBlockMap);
  }
}

export function nativeInputToEditorState(
  nativeInput: HTMLInputElement
): EditorState {
  const contentState = extendedConvertFromHTML(nativeInput.value);
  const cleanedContentState = cleanContentState(contentState);
  return EditorState.createWithContent(cleanedContentState);
}

export function cleanHTML(html: string): string {
  // parse html string into draft content state, then serialize it back to a
  // html string
  const contentState = extendedConvertFromHTML(html);
  const cleanedContentState = cleanContentState(contentState);
  const editorState = EditorState.createWithContent(cleanedContentState);
  return extendedConvertToHTML(cleanedContentState);
}



// WEBPACK FOOTER //
// ./enso_cms/static/enso-cms/js/utils/draftUtils.js